export interface OptimizePlanRequest {
    planId: string;
    connectionId: string;
    strategy?: number; // Optional, if not provided, default strategy will be used
}